import React, { memo, useEffect, useRef, useState } from 'react'
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import MenuItem from './components/MenuItem';
import { MessageTypeConstants } from '../../../services/bot/Message';
import { processSendMessage } from '../../../services/bot/conversation/SendMessage';
import isArray from 'lodash/isArray';
import { setBotWaitLoaderWithShimmer } from '../../../state/actions/loader';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';


const Menu = ({ message }) => {
    const [menuEntries, setMenuEntries] = useState([]);
    const [selectedMenu, setSelectedMenu] = useState(null);
    const [isPopUpOpen, setIsPopUpOpen] = useState(false);
    const autoRedirectHandledRef = useRef("");
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const isOpenChatWidget = useSelector((state) => state.bot.isOpenChatWidget);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const menuIdFromUrl = queryParams.get("tabId");

    useEffect(() => {
        setIsPopUpOpen(false);
        setSelectedMenu(null);
    }, []);


    useEffect(() => {
        if (message?.menuEntries && isArray(message?.menuEntries)) {
            setMenuEntries(message?.menuEntries);
        }
    }, [message?.menuEntries]);


    const handleAction = (menuId) => {
        const { controlId, tabId } = message.options;
        const sendMessageObj = {
            messageType: MessageTypeConstants.MESSAGE_TYPE_MENU_RESPONSE,
            message: {
                controlId,
                tabId,
                selectedEntry: menuId,
            },
        };

        dispatch(setBotWaitLoaderWithShimmer(true));
        processSendMessage(sendMessageObj, true);
        setIsPopUpOpen(false);
        setSelectedMenu(null);
    };


    const handleCardClick = (menu) => {
        if (!menu.submenu) {
            handleAction(menu.id);
        } else {
            setIsPopUpOpen((prev) => !prev);
            setSelectedMenu(menu);
        }
    };

    useEffect(() => {
        if (!menuIdFromUrl || !menuEntries?.length) return;

        let targetMenu = null;
        for (const menuEntry of menuEntries) {
            if (!menuEntry?.submenu && String(menuEntry?.id) === String(menuIdFromUrl)) {
                targetMenu = menuEntry;
                break;
            }

            if (menuEntry?.submenu && isArray(menuEntry.submenu)) {
                const subMenuMatch = menuEntry.submenu.find(
                    (subItem) => !subItem?.submenu && String(subItem?.id) === String(menuIdFromUrl)
                );
                if (subMenuMatch) {
                    targetMenu = subMenuMatch;
                    break;
                }
            }
        }

        if (!targetMenu?.id) return;

        const autoRedirectKey = `${message?.options?.controlId || ""}:${message?.options?.tabId || ""}:${targetMenu.id}`;
        if (autoRedirectHandledRef.current === autoRedirectKey) return;
        autoRedirectHandledRef.current = autoRedirectKey;
    if (location.search || location.hash) {
    navigate(location.pathname, { replace: true });
  }
        handleAction(targetMenu.id);
    }, [menuIdFromUrl, menuEntries, message?.options?.controlId, message?.options?.tabId]);

    return (
        <div className={isOpenChatWidget ? "menu-container xl:px-[30px] xl:py-[100px] lg:px-[10px] lg:py-[80px] p-4 ml-1": "menu-container xl:px-[90px] xl:py-[100px] lg:px-[40px] lg:py-[80px] p-4 ml-1"}>
            <div container spacing={6} className={isOpenChatWidget ? "menu-item md:!gap-3 sm:!gap-3 !gap-2 md:justify-center justify-center grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 lg:max-w-[1215px] max-w-fit mx-auto" :"menu-item md:!gap-7 sm:!gap-3 !gap-2 md:justify-start justify-center grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 lg:max-w-[1215px] max-w-fit mx-auto"}>
                {menuEntries.length > 0 &&
                    menuEntries.map((menuEntry, i) => {
                        const isActive = selectedMenu?.id === menuEntry.id;

                        return (
                            <div key={i} className='max-w-[405px] w-full' >
                                <MenuItem
                                    key={i}
                                    menuEntry={menuEntry}
                                    isActive={isActive}
                                    isPopUpOpen={isPopUpOpen}
                                    selectedMenu={selectedMenu}
                                    onCardClick={() => handleCardClick(menuEntry)}
                                    onSubMenuClick={(subMenuClickedItem) => handleCardClick(subMenuClickedItem)}
                                    isOpenChatWidget={isOpenChatWidget}
                                />
                            </div>
                        )
                    })}
            </div>
        </div>
    )
};

export default memo(Menu)
